import React from 'react';
import { ChevronDown } from 'lucide-react';

export const Hero: React.FC = () => {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.querySelector('#gallery');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full flex flex-col justify-center items-center">
      <div className="flex flex-col items-center animate-fade-in-up">
        <h1 className="font-serif text-[5rem] md:text-[8rem] leading-none text-text mb-6">
          Dardo Art
        </h1>
        
        <div className="flex flex-col items-center gap-4">
          <span className="font-sans text-xs md:text-sm tracking-[0.3em] text-text uppercase">
            Oil on Canvas
          </span>
          <div className="w-12 h-[1px] bg-text/30 mt-2"></div>
        </div>
      </div>

      <a 
        href="#gallery"
        onClick={handleScroll}
        className="absolute bottom-12 flex flex-col items-center gap-2 opacity-60 animate-bounce-slow hover:opacity-100 transition-opacity cursor-pointer"
      >
        <span className="font-serif italic text-sm text-text">Scroll to view</span>
        <ChevronDown size={16} className="text-text" />
      </a>
    </section>
  );
};